import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type GlobalDatePickerState = {
  globalDateArraySlice: { start: number; end: number };
};

// Define the initial state using that type
const initialState: GlobalDatePickerState = {
  globalDateArraySlice: { start: 0, end: 30 },
};

export const globalDatePickerSlice = createSlice({
  name: 'globalDatePickerSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setGlobalDateChartArraySlice(state, action: PayloadAction<{ start: number; end: number }>) {
      state.globalDateArraySlice = action.payload;
    },
  },
});

export const { setGlobalDateChartArraySlice } = globalDatePickerSlice.actions;

export default globalDatePickerSlice.reducer;
